<template>
  <BaseButton primary :disabled="pending" @click="createFacebookChannel">
    Add Facebook Channel
  </BaseButton>
</template>

<script>
import { campaignChannelsClient } from '@/api/clients';

export default {
  props: {
    campaignId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      pending: false,
    };
  },
  methods: {
    setPending(value) {
      this.pending = value;
    },
    async createFacebookChannel() {
      try {
        this.setPending(true);

        await campaignChannelsClient.store(this.campaignId, {
          channableType: 'facebook_campaign',
        });

        this.$emit('saved');
      } catch (error) {
        //
      } finally {
        this.setPending(false);
      }
    },
  },
};
</script>
